var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 451.29 437.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f1f2f2;}.cls-2{fill:#a6dae9;}.cls-3{fill:#fff;}.cls-4{fill:#463647;}.cls-5{fill:#281d28;}.cls-6{fill:#5f5160;}.cls-7{fill:#15b0bf;}.cls-8{fill:#1695a4;}.cls-9{fill:#995f13;}.cls-10{fill:#d1d3d4;}.cls-11{fill:#ea6552;}.cls-12{fill:#facb34;}.cls-13{fill:#f8db1d;}.cls-14{fill:#f8a81d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 183.93,
    y: 323.51,
    width: 83.43,
    height: 69.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.7,343.19a20.06,20.06,0,1,1-20-20.06A20,20,0,0,1,245.7,343.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M225.65,363.24a20.06,20.06,0,0,1-20-18.19q-.09.92-.09,1.86a20.06,20.06,0,1,0,40.11,0q0-.95-.09-1.86A20.05,20.05,0,0,1,225.65,363.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3,42.34H448.33a3,3,0,0,1,3,3V335a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V45.3A3,3,0,0,1,3,42.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 331.76,
    width: 451.29,
    height: 3.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M448.33,42.34H3a3,3,0,0,0-3,3v1.78a3,3,0,0,1,3-3H448.33a3,3,0,0,1,3,3V45.3A3,3,0,0,0,448.33,42.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.68,393H150.62c-3.81,0-6.9,3.62-6.9,8.1v3H307.58v-3C307.58,396.66,304.48,393,300.68,393Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 5.1,
    y: 47.43,
    width: 441.1,
    height: 268.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M441.82,325.47a4.77,4.77,0,1,1-4.77-4.76A4.76,4.76,0,0,1,441.82,325.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M422.84,325.47a1.39,1.39,0,1,1-1.39-1.38A1.39,1.39,0,0,1,422.84,325.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M409.51,325.47a1.38,1.38,0,1,1-1.38-1.38A1.38,1.38,0,0,1,409.51,325.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M396.18,325.47a1.38,1.38,0,1,1-1.38-1.38A1.38,1.38,0,0,1,396.18,325.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.86,325.47a1.39,1.39,0,1,1-1.38-1.38A1.38,1.38,0,0,1,382.86,325.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 425.92,
    width: 451.29,
    height: 11.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368,377.42h-15.8a24.73,24.73,0,0,0-24.73,24.72v2h65.25v-2A24.72,24.72,0,0,0,368,377.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.89,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 47.55,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 78.22,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 108.88,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 139.54,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 170.2,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 200.87,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 231.53,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 262.19,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 292.85,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 323.52,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 354.18,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 384.84,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 415.5,
    y: 422.61,
    width: 18.9,
    height: 3.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M375.82,274.87c0,10.33-67.24,18.7-150.17,18.7S75.48,285.2,75.48,274.87s67.23-18.69,150.17-18.69S375.82,264.55,375.82,274.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "79.2 113.82 216.43 0 353.67 113.82 353.67 274.87 79.2 274.87 79.2 113.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.48,
    y: 23.42,
    width: 189.9,
    height: 186.87,
    rx: 2.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M308.88,23.42H124a2.51,2.51,0,0,0-2.51,2.51v1.86A2.51,2.51,0,0,1,124,25.28H308.88a2.5,2.5,0,0,1,2.5,2.51V25.93A2.5,2.5,0,0,0,308.88,23.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 203.92,
    y: 47.38,
    width: 83.51,
    height: 9.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 203.92,
    y: 67.05,
    width: 83.51,
    height: 9.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 145.44,
    y: 47.38,
    width: 49.3,
    height: 49.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 203.92,
    y: 86.72,
    width: 83.51,
    height: 9.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 145.44,
    y: 106.39,
    width: 141.98,
    height: 9.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 145.44,
    y: 145.73,
    width: 141.98,
    height: 9.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 145.44,
    y: 126.06,
    width: 141.98,
    height: 9.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 145.44,
    y: 165.4,
    width: 141.98,
    height: 9.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 145.44,
    y: 185.08,
    width: 141.98,
    height: 9.96
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "79.2 113.82 193 194.35 79.2 274.87 79.2 113.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "79.2 113.82 79.2 115.4 190.77 194.35 79.2 273.29 79.2 274.87 193 194.35 79.2 113.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "353.67 113.82 239.86 194.35 353.67 274.87 353.67 113.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "353.67 113.82 353.67 115.4 242.09 194.35 353.67 273.29 353.67 274.87 239.86 194.35 353.67 113.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "239.96 194.35 193 194.35 193 194.28 79.2 274.87 353.67 274.87 239.96 194.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M394.8,404.18H325.45v-4.42a2.11,2.11,0,0,1,2.11-2.1H392.7a2.1,2.1,0,0,1,2.1,2.1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.031889c12e14668dc85bbaa943dd20a8.svg";
export { ForwardRef as ReactComponent };